import fetcher from "@/utils/fetcher";
import { triggerContentUpdated } from "@/utils/init-updated";

export const modalUpdatedEventName = "MODAL_UPDATED";

const fallbackContent =
    "<h1>Ups, der gik noget galt</h1><div><p>Vi kan desv&aelig;rre ikke vise det indhold vi gerne ville</p></div>";

async function getModalContent(path: string): Promise<string | undefined> {
    try {
        const response = await fetcher(path, {});
        const html = await response.text();

        const start = html.indexOf("<dialog");
        const endNeedle = "</dialog>";
        const end = html.indexOf(endNeedle) + endNeedle.length;

        if (start < 0 || end < start) {
            throw "Invalid modal page";
        }

        const content = html.substring(start, end);
        return content;
    } catch (err) {
        console.log("Error while fetching modal content", err);
        return undefined;
    }
}

function getContentAsElement(content: string | undefined) {
    if (content == undefined) {
        return undefined;
    }

    const body = document.body;
    const d = (() => {
        if (content.indexOf("<dialog") === -1) {
            const container = document.createElement(
                "dialog",
            ) as HTMLDialogElement;
            container.className = "inset-0";
            container.innerHTML = content;
            return container;
        } else {
            const container = document.createElement("div") as HTMLElement;
            container.innerHTML = content;
            return container.firstChild as HTMLDialogElement;
        }
    })();

    d.open = false;
    body.appendChild(d);

    return d;
}
export function showSpinner() {
    const elm: HTMLDialogElement =
        document.querySelector("dialog.spinner") ??
        (() => {
            const d = document.createElement("dialog") as HTMLDialogElement;
            d.className = "spinner";
            d.open = false;
            document.body.appendChild(d);
            return d;
        })();

    elm.innerHTML = '<div class="icon-spinner"></div>';
    if (!elm.open) {
        elm.showModal();
    }
}

export function hideSpinner() {
    const elm: HTMLDialogElement | null =
        document.querySelector("dialog.spinner");
    if (elm?.open) {
        elm.close();
    }
}

export type OpenModalOptions = {
    name: string;
    className?: string;
    insertContent?: (contentElement: HTMLElement, content: string) => void;
    onClose?: (dialogElement: HTMLDialogElement) => void;
};

export async function openModal(options: OpenModalOptions) {
    const { name, className } = options;
    const path = `/modals/${name}`;

    showSpinner();

    const content = await getModalContent(path);
    const hasFailure = content === undefined;
    const d = getContentAsElement(content || fallbackContent);
    if (!d) {
        console.warn('Could not get modal content', options);
        return;
    }

    const body = document.createElement("div");
    body.className = "modal-body" + (className ? " " + className : "");
    while (d.firstChild) {
        body.appendChild(d.firstChild);
    }
    d.appendChild(body);

    // Cleanup when closing
    d.onclose = () => {
        if (options.onClose) {
            options.onClose(d);
        }

        document.body.removeChild(d);
    };

    // Support close by clicking on backdrop or the close button
    d.onclick = (e) => {
        const target = e.target as HTMLElement;
        if (target === d || target.closest(".modal-close")) {
            d.close();
        }
    };

    if (options.insertContent && !hasFailure) {
        options.insertContent(body, content);
    }

    triggerContentUpdated(d);

    hideSpinner();
    d.showModal();
}
